import { useUpdate, useTranslate } from "@refinedev/core";
import { Workspace } from "types";
import { useAntTheme } from "hooks/useAntTheme";
import { Button, Flex, Input, Modal, Typography } from "antd";
import { useState } from "react";

interface EditWorkspaceModalProps {
  open: boolean;
  workspace: Workspace;
  onCancel: () => void;
  onSuccess: () => void;
}

export const EditWorkspaceModal = ({
  open,
  workspace,
  onCancel,
  onSuccess,
}: EditWorkspaceModalProps) => {
  const t = useTranslate();
  const { theme } = useAntTheme();
  const [workspaceName, setWorkspaceName] = useState(workspace.name);

  const { mutateAsync: updateWorkspace, isPending } = useUpdate<Workspace>();

  const handleUpdateWorkspace = async () => {
    if (!workspaceName.trim()) return;

    await updateWorkspace({
      resource: "api/workspaces",
      id: workspace.id,
      values: {
        name: workspaceName,
      },
    });

    onSuccess();
  };

  const hasChanges = workspaceName.trim() !== workspace.name;

  return (
    <Modal
      open={open}
      centered
      styles={{
        content: { backgroundColor: theme.colorModalBgDesignSystem },
        header: { alignItems: "flex-start" },
      }}
      className="workspace-modal"
      onCancel={onCancel}
      title={
        <Typography.Title
          style={{
            fontSize: 20,
            backgroundColor: theme.colorModalBgDesignSystem,
            color: theme.colorTextDesignSystem,
            margin: 0,
          }}
        >
          {t("media.workspaces.index.editWorkspace")}
        </Typography.Title>
      }
      footer={null}
    >
      <Flex vertical gap={20}>
        <Flex vertical>
          <Typography.Title
            style={{ fontSize: 14, fontWeight: 500, color: "#000" }}
          >
            {t("media.workspaces.index.workspaceName")}
          </Typography.Title>
          <Input
            value={workspaceName}
            onChange={(e) => setWorkspaceName(e.target.value)}
          />
        </Flex>
        <Flex justify="center" gap={12}>
          <Button
            size="large"
            style={{ width: "200px" }}
            shape="round"
            onClick={onCancel}
          >
            {t("media.workspaces.index.cancel")}
          </Button>
          <Button
            type="primary"
            size="large"
            style={{ width: "200px" }}
            shape="round"
            onClick={handleUpdateWorkspace}
            loading={isPending}
            disabled={!workspaceName.trim() || !hasChanges}
          >
            {t("media.workspaces.index.save")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
